import { Input } from '@/components/ui/input';
import { FC } from 'react';
import { LuMinus, LuPlus } from 'react-icons/lu';

export const Counter: FC<{ onChange: (n: number) => void; value: number }> = ({
  onChange,
  value,
}) => {
  return (
    <div className="flex flex-row justify-center gap-4 items-center">
      <span
        className="p-2 rounded-lg bg-disabled"
        onClick={() => value >= 1 && onChange((value -= 1))}
      >
        <LuMinus className="w-[16px] h-[16px]" />
      </span>
      <Input
        value={value}
        type="text"
        inputMode="numeric"
        onChange={(e) => onChange(parseInt(e.target.value.replace(/[^\d]/, '')))}
        className="text-center w-full"
      />
      <span onClick={() => onChange((value += 1))} className="p-2 rounded-lg bg-disabled">
        <LuPlus className="w-[16px] h-[16px]" />
      </span>
    </div>
  );
};
